export default __webpack_public_path__ + "static/media/user.b6491f07.svg";